import axios from "axios";
import moment from 'moment';

import { config } from "../../config";
import { User } from '@/entity/authentication/user';
import { Transaction, TransactionStatus } from '@/entity/wallet/transaction';
import { LocalStorage } from '@/data/localstorage';
import { WalletSummary } from '@/entity/wallet/summary';

export class WalletService {
    async initAmountInUserWallet(amount: number, user: User): Promise<any> {
        let transactionInfo = {
            userId: user.id,
            amount: amount,
            source: "Razorpay",
            status: {
                code: "S"
            }
        }
        let response = await axios.post(config.api.host + "/accounts/" + user.id + "/wallets", {
            data: {
                ...transactionInfo
            }
        },
        {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });
        let txnInfo = response.data;
        
        return Promise.resolve(txnInfo)
    }

    async loadAmountInUserWallet(payment_id: string, order_id : string, signature : string, pgcallbackurl: string): Promise<void> {
        let transactionInfo = {
            razorpay_payment_id: payment_id,
            razorpay_order_id: order_id,
            razorpay_signature: signature
        }
        await axios.post(config.api.host + pgcallbackurl, transactionInfo,
        {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });
        return Promise.resolve()
    }

    async summaryOfUser(user: User): Promise<WalletSummary> {
        let response = await axios.get(config.api.host + "/accounts/" + user.id + "/wallet", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let summaryInfo = response.data.data
        let summary = new WalletSummary(
            summaryInfo.currentAmount,
            summaryInfo.committedAmount,
            summaryInfo.nettAmount
        )
        return Promise.resolve(summary)
    }

    async transactionsOfUser(user: User): Promise<Transaction[]> {
        let response = await axios.get(config.api.host + "/accounts/" + user.id + "/wallets?data[userId]="+ user.id +"]&data[page]=1&data[page-size]=1000", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let transactionsInfos: any[] = response.data.data        
        let transactions: Transaction[] = []
        transactionsInfos.forEach(transactionInfo => {
            transactions.push(this.transactionOfTransactionInfo(transactionInfo))
        });
        return Promise.resolve(transactions)
    }

    transactionOfTransactionInfo(transactionInfo: any): Transaction {
        return new Transaction(
            transactionInfo.transactionId ? transactionInfo.transactionId : undefined,
            new Date(transactionInfo.topupDate),//, "DD MMM YYYY").toDate(),
            transactionInfo.amount,
            transactionInfo.remarks,
            transactionInfo.source,
            transactionInfo.referenceNo ? transactionInfo.referenceNo : undefined,
            new TransactionStatus(transactionInfo.status.code, transactionInfo.status.description),
            transactionInfo.bankReference
        )
    }
}